export default "__VITE_ASSET__DwpnTCPy__"